import { request } from "./http";
const BASE = "comercial-app/erp";
const fetchJson = (url, opts = {}) => request(url.replace(/\/+/g, "/"), opts);
export async function testApi() {
  return await fetch(`${BASE}/check-version-uxbi`);
}

export async function getCatalogo({
  endpoint,
  search = "",
  page = 1,
  limit = 15,
  perfil = null,
  extraFilters = [],
  trash = null,
} = {}) {
  const filters = [];

  filters.push(...extraFilters);
  if (search.trim()) {
    const resource = endpoint.replace(/^\//, "");
    const fields = {
      clientes: ["nombre", "clave", "rfc", "alias_1", "alias_2"],
      productos: ["descripcion", "clave", "alias_1", "alias_2"],
      empresas: ["nombre"],
      usuarios: ["nombre"],
      encabezados: ["folio", "referencia"],
    };
    filters.push({
      condition: "AND",
      group: (fields[resource] || ["descripcion"]).map((property) => ({
        property,
        operator: "LIKE",
        value: search.trim(),
        condition: "OR",
      })),
    });
  }

  const queryParams = new URLSearchParams({
    page,
    lookup: "1",
    start: (page - 1) * limit,
    limit,
    perfil: perfil,
    filter: JSON.stringify(filters),
  });

  if (trash) {
    queryParams.append("trash", trash);
  }

  return fetchJson(`${BASE}/${endpoint}?${queryParams}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("authToken")}`,
    },
  });
}

export async function getEncabezados({
  search = "",
  page = 1,
  limit = 15,
  perfil = "all",
  extraFilters = [],
  user,
  esAdmin,
  esAgenteVentas,
  seguimientoVentas,
} = {}) {
  const filters = [];

  if (search) {
    filters.push({
      group: [
        {
          property: "folio",
          operator: "LIKE",
          value: search,
        },
        {
          property: "nombre",
          operator: "LIKE",
          relation: "cliente",
          value: search,
          condition: "OR",
        },
        {
          property: "clave",
          operator: "LIKE",
          relation: "cliente",
          value: search,
          condition: "OR",
        },
      ],
      condition: "AND",
    });
  }

  if (esAgenteVentas && !esAdmin && !seguimientoVentas) {
    filters.push({
      group: [
        {
          property: "id_agente_ventas",
          relation: "cliente",
          operator: "=",
          value: user.id,
        },
        {
          property: "id_agente_ventas2",
          operator: "=",
          relation: "cliente",
          value: user.id,
          condition: "OR",
        },
      ],
      condition: "AND",
    });
  }

  if (user.id_empresa && !esAdmin) {
    filters.push({
      property: "id_empresa",
      value: user.id_empresa,
      operator: "=",
      condition: "AND",
    });
  }

  filters.push(...extraFilters);

  const queryParams = new URLSearchParams({
    page,
    lookup: "1",
    start: (page - 1) * limit,
    limit,
    perfil: perfil,
    filter: JSON.stringify(filters),
    sort: JSON.stringify([{ property: "id", direction: "DESC" }]),
  });

  return fetchJson(`${BASE}/encabezados?${queryParams}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("authToken")}`,
    },
  });
}

export const getEmpresas = (params) =>
  getCatalogo({ endpoint: "/empresas", ...params });

export const getZonas = (params) =>
  getCatalogo({ endpoint: "/zonas", ...params });

export const getGruposCliente = (params) =>
  getCatalogo({ endpoint: "/clientes-grupos", ...params });

export const getFuentesProspecto = (params) =>
  getCatalogo({ endpoint: "/fuentes", ...params });

export const getAgentes = (params) =>
  getCatalogo({ endpoint: "/usuarios", ...params });
export const getAgentesVentas = (params = {}) =>
  getCatalogo({
    endpoint: "/usuarios",
    ...params,
    extraFilters: [
      ...(params.extraFilters || []),
      {
        relation: "roles",
        property: "name",
        operator: "=",
        value: "VEND",
        condition: "AND",
      },
    ],
  });

export const getProbabilidadesCierre = (params) =>
  getCatalogo({ endpoint: "/probabilidades", ...params });

export const getClientes = (params) =>
  getCatalogo({ endpoint: "/clientes", ...params });

export const getEncabezado = (params) =>
  getEncabezados({ endpoint: "/encabezados", ...params });

export const getOportunidadesPerdidas = (params) =>
  getCatalogo({ endpoint: "/oportunidades-perdidas", ...params });

export const getTipoSeguimientos = (params) =>
  getCatalogo({ endpoint: "/seguimientos-tipos", ...params });

export const getPreciosEspeciales = (params) =>
  getCatalogo({ endpoint: "/precios-especiales", ...params });

export const getProductos = (params) =>
  getCatalogo({ endpoint: "/productos", ...params });

/**PORSPECTOS */
export async function getProspectos({
  search = "",
  page = 1,
  limit = 15,
  extraFilters = [],
  user = null,
  esAgenteVentas = false,
  esAdmin = false,
  seguimientoVentas = false,
} = {}) {
  const filters = [];

  // Filtro base
  filters.push({
    property: "cliente_prospecto",
    value: 0,
    operator: "=",
    condition: "AND",
  });

  if (esAgenteVentas && !esAdmin && !seguimientoVentas && user?.id) {
    filters.push({
      group: [
        {
          property: "id_agente_ventas",
          operator: "=",
          value: user.id,
        },
        {
          property: "id_agente_ventas2",
          operator: "=",
          value: user.id,
          condition: "OR",
        },
      ],
      condition: "AND",
    });
  }

  // Búsqueda
  if (search) {
    filters.push({
      group: [
        {
          property: "id",
          operator: "=",
          value: search,
        },
        {
          property: "clave",
          operator: "LIKE",
          value: search,
          condition: "OR",
        },
        {
          property: "nombre",
          operator: "LIKE",
          value: search,
          condition: "OR",
        },
        {
          property: "rfc",
          operator: "LIKE",
          value: search,
          condition: "OR",
        },
        {
          property: "email",
          operator: "LIKE",
          value: search,
          condition: "OR",
        },
      ],
      condition: "AND",
    });
  }

  // Extras
  filters.push(...extraFilters);

  const queryParams = new URLSearchParams({
    page,
    lookup: "1",
    start: (page - 1) * limit,
    limit,
    perfil: "detalles_edicion",
    filter: JSON.stringify(filters),
    sort: JSON.stringify([{ property: "id", direction: "DESC" }]),
  });

  return fetchJson(`${BASE}/clientes?lookup=1&${queryParams}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("authToken")}`,
    },
  });
}

export async function getClientesSimilares(nombre) {
  const filters = [];

  if (nombre) {
    filters.push({
      property: "nombre",
      value: nombre,
      operator: "LIKE",
      condition: "AND",
    });
  }

  const queryParams = new URLSearchParams({
    page: 1,
    start: 0,
    limit: 10,
    filter: JSON.stringify(filters),
  });

  return fetchJson(`${BASE}/clientes?lookup=1&${queryParams}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("authToken")}`,
    },
  });
}

export async function createProspecto(payload) {
  return fetchJson(`${BASE}/clientes`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("authToken")}`,
    },
    body: JSON.stringify(payload),
  });
}

export async function updateProspecto(payload) {
  return fetchJson(`${BASE}/clientes/${payload.id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("authToken")}`,
    },
    body: JSON.stringify(payload),
  });
}

export async function deleteProspecto(id) {
  return fetchJson(`${BASE}/clientes/${id}`, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("authToken")}`,
    },
  });
}

/**OPORTUNIDADES */
export async function getOportunidades({
  search = "",
  page = 1,
  limit = 15,
  extraFilters = [],
  user = null,
  esAgenteVentas = false,
  esAdmin = false,
  seguimientoVentas = false,
} = {}) {
  const filters = [];

  // Filtro por agente
  if (esAgenteVentas && !esAdmin && !seguimientoVentas && user?.id) {
    filters.push({
      group: [
        {
          property: "id_agente_ventas",
          operator: "=",
          value: user.id,
        },
        {
          property: "id_agente_ventas2",
          operator: "=",
          value: user.id,
          condition: "OR",
        },
      ],
      condition: "AND",
    });
  }

  // Búsqueda
  if (search) {
    filters.push({
      group: [
        {
          property: "id",
          operator: "=",
          value: search,
        },
        {
          property: "clave",
          operator: "LIKE",
          relation: "cliente",
          value: search,
          condition: "OR",
        },
        {
          property: "nombre",
          operator: "LIKE",
          relation: "cliente",
          value: search,
          condition: "OR",
        },
        {
          property: "rfc",
          operator: "LIKE",
          relation: "cliente",
          value: search,
          condition: "OR",
        },
        {
          property: "email",
          operator: "LIKE",
          relation: "cliente",
          value: search,
          condition: "OR",
        },
        {
          property: "nombre",
          operator: "LIKE",
          value: search,
          condition: "OR",
        },
      ],
      condition: "AND",
    });
  }

  filters.push(...extraFilters);

  const queryParams = new URLSearchParams({
    page,
    lookup: "1",
    start: (page - 1) * limit,
    limit,
    perfil: "all",
    filter: JSON.stringify(filters),
    sort: JSON.stringify([{ property: "id", direction: "DESC" }]),
  });

  return fetchJson(`${BASE}/oportunidades?${queryParams}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("authToken")}`,
    },
  });
}

export async function createOportunidad(payload) {
  return fetchJson(`${BASE}/oportunidades`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("authToken")}`,
    },
    body: JSON.stringify(payload),
  });
}

export async function updateOportunidad(payload) {
  return fetchJson(`${BASE}/oportunidades/${payload.id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("authToken")}`,
    },
    body: JSON.stringify(payload),
  });
}

export async function deleteOportunidad(id) {
  return fetchJson(`${BASE}/oportunidades/${id}`, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("authToken")}`,
    },
  });
}

export async function getCurrentUserAPI() {
  return fetchJson(`${BASE}/current-user`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("authToken")}`,
    },
  });
}

// SEGUIMIENTOS
export async function getSeguimientos({
  search = "",
  page = 1,
  limit = 15,
  extraFilters = [],
  user = null,
  esAgenteVentas = false,
  esAdmin = false,
  seguimientoVentas = false,
} = {}) {
  const filters = [];

  // Filtro base
  filters.push({
    group: [
      {
        property: "estatus",
        operator: "!=",
        value: "Perdido",
        condition: "AND",
      },
      {
        property: "estatus",
        operator: "!=",
        value: "Ganado",
        condition: "AND",
      },
      {
        property: "id_seguimiento_posterior",
        operator: "=",
        value: 0,
        condition: "AND",
      },
      {
        property: "tipo_seguimiento",
        operator: "=",
        value: "CL",
        condition: "AND",
      },
    ],
    condition: "AND",
  });

  if (esAgenteVentas && !esAdmin && !seguimientoVentas && user?.id) {
    filters.push({
      group: [
        {
          property: "id_usuario",
          operator: "=",
          value: user.id,
        },
        {
          property: "id_usuario_compartido",
          operator: "=",
          value: user.id,
          condition: "OR",
        },
      ],
      condition: "AND",
    });
  }

  // Búsqueda
  if (search) {
    filters.push({
      group: [
        {
          property: "id",
          operator: "=",
          value: search,
        },
        {
          property: "clave",
          operator: "LIKE",
          relation: "cliente",
          value: search,
          condition: "OR",
        },
        {
          property: "nombre",
          operator: "LIKE",
          relation: "cliente",
          value: search,
          condition: "OR",
        },
        {
          property: "rfc",
          operator: "LIKE",
          relation: "cliente",
          value: search,
          condition: "OR",
        },
        {
          property: "email",
          operator: "LIKE",
          relation: "cliente",
          value: search,
          condition: "OR",
        },
      ],
      condition: "AND",
    });
  }

  // Extras
  filters.push(...extraFilters);

  const queryParams = new URLSearchParams({
    page,
    lookup: "1",
    start: (page - 1) * limit,
    limit,
    perfil: "all",
    filter: JSON.stringify(filters),
    sort: JSON.stringify([{ property: "fecha_vencimiento", direction: "ASC" }]),
  });

  return fetchJson(`${BASE}/actividades?${queryParams}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("authToken")}`,
    },
  });
}

export async function createSeguimiento(payload) {
  return fetchJson(`${BASE}/actividades`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("authToken")}`,
    },
    body: JSON.stringify(payload),
  });
}

export async function updateSeguimiento(payload) {
  return fetchJson(`${BASE}/actividades/${payload.id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("authToken")}`,
    },
    body: JSON.stringify(payload),
  });
}

export async function deleteSeguimiento(id) {
  return fetchJson(`${BASE}/actividades/${id}`, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("authToken")}`,
    },
  });
}

// PEDIDOS
export async function createPedido(payload, edicion = false, id = null) {
  let url = `${BASE}/nuevo-documento`;
  let headers = {
    Authorization: `Bearer ${localStorage.getItem("authToken")}`,
  };

  if (edicion) {
    url = `${BASE}/editar-documento/${id}`;
    headers["X-HTTP-Method-Override"] = "PATCH";
  }

  const fd = new FormData();
  fd.append("payload", JSON.stringify(payload));

  const response = await fetch(url, {
    method: "POST",
    headers,
    body: fd,
  });

  if (!response.ok) {
    throw new Error("Error en la petición");
  }

  return response.json();
}

export async function updatePedido(payload, id) {
  const fd = new FormData();

  fd.append("payload", JSON.stringify(payload));

  const response = await fetch(`${BASE}/editar-documento/${id}`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("authToken")}`,
      "X-HTTP-Method-Override": "PATCH",
    },
    body: fd,
  });

  if (!response.ok) {
    throw new Error("Error al actualizar documento");
  }

  return response.json();
}

export async function deletePedido(id) {
  const params = new URLSearchParams();

  params.append("id_documento", id);

  const response = await fetch(`${BASE}/cancelar-documento`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("authToken")}`,
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: params,
  });

  if (!response.ok) {
    throw new Error("Error al cancelar documento");
  }

  return response.json();
}

export function logout() {
  localStorage.removeItem("authToken");
  localStorage.removeItem("user");
  localStorage.removeItem("empresa");
  localStorage.removeItem("permissions");

  window.location.href = "/login";
}
